var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActBox',{attrs:{"from":"babe","postActivityCountries":_vm.postActivityCountries,"postActivityInfo":_vm.postActivityInfoBabe,"postActivityRank":_vm.postActivityRankBabe}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429b44f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/babe/actdetail.vue
// module id = null
// module chunks = 